var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanRotateArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 0v20h-20v-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.12416667 6.4025.87583333.87583333-.98416667-.98416666.98416667-.98416667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.86166667 7.88-.0000001.00000012c-1.31965833 1.753-.96835833 4.24387498.78463667 5.56353338 1.753 1.3196583 4.24387496.9683583 5.56353336-.7846367 1.3196583-1.753.9683583-4.24387501-.7846367-5.56353334-.942825-.70976084-2.1523917-.96364167-3.30103333-.69286334"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 15,
    rx: 2.301167,
    width: 15,
    x: 2.416667,
    y: 2.50115
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20 20h-20v-20h20z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanRotateArrow);
export default __webpack_public_path__ + "static/media/loan-rotate-arrow.79e36a1e4ea9c5df50cd26218fa89a18.svg";
export { ForwardRef as ReactComponent };